var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101,
    height: 44,
    viewBox: "0 0 101 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #032541;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #dc3545;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3734",
    "data-name": "Rectangle 3734",
    className: "cls-1",
    width: 101,
    height: 44,
    transform: "translate(0 -0.027)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zed_Logo",
    "data-name": "Zed Logo",
    className: "cls-2",
    transform: "translate(0 0.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17230",
    "data-name": "Group 17230",
    transform: "translate(1.988 2.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17229",
    "data-name": "Group 17229",
    transform: "translate(0 8.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23014",
    "data-name": "Path 23014",
    className: "cls-1",
    d: "M1377.941,1217.794a10.249,10.249,0,0,0,.892,4.236,11.648,11.648,0,0,0,14.989,5.83,11.49,11.49,0,0,0,3.647-2.34,10.465,10.465,0,0,0,1.9-2.451h4.3l-.169.426a15.011,15.011,0,0,1-2.315,3.624,15.741,15.741,0,0,1-17.774,4.184,14.443,14.443,0,0,1-8.473-18.553c2.82-7.352,11.2-11.289,19.019-8.94a15.917,15.917,0,0,1,3.99,1.838,15.162,15.162,0,0,1,5.553,6.447,12.655,12.655,0,0,1,1.172,4.582h-26.677a2.806,2.806,0,0,0-.053.56Zm22.042-4.1a10.95,10.95,0,0,0-4.129-4.928,12.029,12.029,0,0,0-12.95,0,10.941,10.941,0,0,0-4.129,4.928Z",
    transform: "translate(-1341.512 -1202.525)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-1",
    d: "M638.439,1218.786l.965-.07c1.747,0,3.493-.008,5.239.007a.661.661,0,0,0,.618-.317q4.2-5.954,8.41-11.9,6.152-8.694,12.3-17.388c.061-.086.124-.207.2-.321a2.2,2.2,0,0,0-.275,0q-2.825,0-5.651,0a.441.441,0,0,0-.4.229q-3.189,4.521-6.383,9.035c-4.375,6.184-9.473,12.936-13.849,19.119C639.138,1217.856,638.969,1218.032,638.439,1218.786Z",
    transform: "translate(-638.374 -1188.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M946.616,1785.511h0c-2.324,0-4.648,0-6.973,0-.284,0-.368.083-.366.352q.019,2.068,0,4.129c0,.279.1.345.373.345q6.988-.008,13.975,0c.257,0,.333-.073.331-.32-.012-1.367-.006-2.734-.006-4.1,0-.4,0-.4-.419-.4Z",
    transform: "translate(-925.954 -1760.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-3",
    d: "M636.974,1193.486c.108.008.174.017.241.017q7.074,0,14.147.005c.227,0,.31-.057.309-.282q-.013-2.078,0-4.157c0-.239-.066-.329-.33-.329q-7.03.008-14.061,0c-.247,0-.315.083-.314.312.01,1.386.006,2.771.007,4.157Z",
    transform: "translate(-636.966 -1188.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-1",
    d: "M1087.218,1622.584v-4.217c-.141-.007-.265-.019-.389-.019q-3.864,0-7.73,0c-.313,0-.418.059-.415.288q.021,1.827,0,3.652c0,.231.083.307.424.306,2.577-.01,5.153-.006,7.73-.006Z",
    transform: "translate(-1059.216 -1600.266)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23050",
    "data-name": "Path 23050",
    className: "cls-1",
    d: "M953.849,1785.911c0-.4,0-.4-.419-.4l-6.915,0c-2.324,0-4.648,0-6.972-.005-.284,0-.368.083-.366.353q.019,2.067,0,4.129c0,.279.1.345.373.345q6.988-.008,13.975,0c.257,0,.333-.073.331-.32C953.842,1788.646,953.849,1787.279,953.849,1785.911Z",
    transform: "translate(-925.857 -1751.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23051",
    "data-name": "Path 23051",
    className: "cls-1",
    d: "M1079.007,1622.589c2.577-.01,5.153-.006,7.73-.006h.38v-4.217c-.141-.007-.265-.019-.389-.019q-3.865,0-7.73,0c-.313,0-.418.059-.415.288q.022,1.827,0,3.652C1078.583,1622.515,1078.666,1622.591,1079.007,1622.589Z",
    transform: "translate(-1059.12 -1591.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23053",
    "data-name": "Path 23053",
    className: "cls-1",
    d: "M2144.115,1011.343a10.753,10.753,0,0,1,6.113-14.307,11.647,11.647,0,0,1,14.985,5.836,10.3,10.3,0,0,1,.865,3.418h3.935l0-23.109H2166.1V998.1a12.125,12.125,0,0,0-4.908-4,14.462,14.462,0,0,0-6.531-1.654,15.567,15.567,0,0,0-5.971,1.147,15.023,15.023,0,0,0-8.173,7.8,14.425,14.425,0,0,0,8.174,19.205,15.955,15.955,0,0,0,9.238.819v-3.851A11.61,11.61,0,0,1,2144.115,1011.343Z",
    transform: "translate(-2073.098 -983.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23054",
    "data-name": "Path 23054",
    className: "cls-3",
    d: "M2573.989,1532.371h-3.936q.031.406.029.815v0a10.29,10.29,0,0,1-.893,4.236,11.2,11.2,0,0,1-6.112,5.836,11.927,11.927,0,0,1-1.166.4v3.851a15.186,15.186,0,0,0,10.877-8.623,13.719,13.719,0,0,0,1.2-5.7Z",
    transform: "translate(-2477.074 -1509.262)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZedLogo);
export default __webpack_public_path__ + "static/media/zed-logo.78d2934b4fcb143a2d75bd6dc146326c.svg";
export { ForwardRef as ReactComponent };